export default __webpack_public_path__ + "images/Damrei-Sa-Bas-relief-on-exterior-wall-fence.webp";